export function camelCase(value) {
  let words = value.split(" ");
  let sentence = [];
  for (let index = 0; index < words.length; index++) {
    const item = words[index];
    sentence.push(item[0] + item.substring(1).toLowerCase());
  }
  return sentence.join(" ");
}
